import MyChart from "../../components/Chart/Chart";
import { useGetUrlView } from "../../hooks/useCrm";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
import { CrmChartStyle } from "../CrmChart/CrmChartStyle";
import Loading from "../Loadings/LoadingTable";

const CrmChartAppUse = () => {
  const { data: chart, isLoading } = useGetUrlView();
  let dates = [];
  let user = [];
  let use = [];
  console.log(chart);
  const chartData = chart?.data?.log_chart.map((item) => {
    dates.push(MiladiToShamsi(item.date));
    user.push(item.log_user);
    use.push(item.log_use);
  });

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        intersect: false,
      },
      title: {
        display: true,
        text: "نمودار استفاده از اپلیکیشن",
      },
    },
  };
  const labels = dates;
  const data = {
    labels,
    datasets: [
      {
        label: "افراد استفاده کننده",
        data: user,
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "دفعات استفاده",
        data: use,
        backgroundColor: "rgba(8, 122, 27, 0.5)",
      },
    ],
  };
  return (
    <CrmChartStyle>
      {isLoading ? (
        <Loading />
      ) : (
        <MyChart data={data} sell={"فروش"} options={options} labels={labels} />
      )}
    </CrmChartStyle>
  );
};

export default CrmChartAppUse;
